// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Services_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/services/salvar
 *
 * Creates or updates a service. When so_service_id is provided, updates existing;
 * otherwise creates new. Price is stored in cents (multiply by 100).
 */
import { registerContract } from './validate'

export interface Services_SalvarInput {
so_service_name: string
so_service_category_id: number
so_service_default_price: number
so_service_id?: number
so_service_description?: string
so_service_color?: string
}

registerContract('Services_SalvarInput', {
  so_service_name:          { type: 'string',  required: true },
  so_service_category_id:   { type: 'number',  required: true },
  so_service_default_price: { type: 'number',  required: true },
  so_service_id:            { type: 'number',  required: false },
  so_service_description:   { type: 'string',  required: false },
  so_service_color:         { type: 'string',  required: false },
})
